import { AutoComplete, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { getInsuranceTypesList } from "../../../../../../../services/tasyInsuranceType.service";

const translationPath = "page.4uBus.integrationRule.integrationRuleMov.";

export const PatientEncounterTypeExternalIdThen = memo(() => {
  const { t } = useTranslation();

  const { sendRequest } = useFetch(getInsuranceTypesList);

  const [options, setOptions] = useState<ISelectType[]>([]);

  const params = useMemo(() => ({ Identifier: 12 }), []);

  const fetchOptions = useCallback(async () => {
    const { data, success } = await sendRequest(params);
    if (data && success) {
      setOptions(
        data.map((item) => ({
          id: item.identifierValue,
          name: item.domainValueName,
        })),
      );
    }
  }, [sendRequest, params]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  return (
    <Grid item xs={12} sm={6}>
      <AutoComplete
        options={options}
        name="patientEncounterTypeExternalIdThen"
        size="small"
        fullWidth
        getOptionLabel={({ name }) => name}
        label={t(translationPath + "patient_encounter_type_external_id_then")}
      />
    </Grid>
  );
});
